import { clsx } from 'clsx';
import { UserIcon } from '../icons/react/user.tsx';
import { followersV2, followersV2Count } from './followers-v2.css.ts';

export const FollowersV2 = ({
  count,
  className,
}: {
  count: string;
  className?: string;
}) => (
  <span className={clsx(followersV2, className)}>
    <UserIcon />
    <span className={followersV2Count}>{count}</span>
  </span>
);
